import { Popover, FloatButton, Switch, Row } from "antd";
import React from "react";
import { LineChartOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";

const StatsButton = ({showStats, setShowStats}) => {
  return (
    <>
      <Popover
        placement="left"
        content={
          <Row align="middle">
            <div style={{margin: 8}}>Show / Hide statistics</div>
            <Switch 
              checked={showStats} 
              onChange={setShowStats} 
              size="large"  
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
            />
          </Row>
        }
      >
        <FloatButton icon={<LineChartOutlined />} />
      </Popover>
    </>
  );
};

export default StatsButton;
